import { QueryStatus } from "@tanstack/react-query";

import { AuthQueries } from "@/queries/AuthQueries.ts";
import { ConfigQueries } from "@/queries/ConfigQueries.ts";
import { DeviceQueries } from "@/queries/DeviceQueries.ts";
import { PatientQueries } from "@/queries/PatientQueries.ts";

export const Queries = {
  auth: new AuthQueries(),
  device: new DeviceQueries(),
  patient: new PatientQueries(),
  config: new ConfigQueries(),
};

export type Status = QueryStatus | "idle";
